// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

export const PanelDeleteMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item className="hover:bg-red-300/[.48]" onSelect={onSelect}>
      <Icon name="delete" />
      Delete panel
    </DropdownMenu.Item>
  );
};
